module.exports = __webpack_public_path__ + "img/gentou.98e579ce.jpg";